import script from "./ImprimirChamada.vue?vue&type=script&setup=true&lang=js"
export * from "./ImprimirChamada.vue?vue&type=script&setup=true&lang=js"

import "./ImprimirChamada.vue?vue&type=style&index=0&id=63a97d5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a97d5a"]])

export default __exports__